import { Instagram, Linkedin, Video, Youtube } from 'lucide-react'
import { FacebookIcon, PinterestIcon } from 'components'
import { CreativeType, creativeTypeMeta } from '../types'
import { XLogo } from './XLogo'

const typeIcons: Record<CreativeType, React.ReactNode> = {
  [CreativeType.InstagramPost]: <Instagram size={12} />,
  [CreativeType.FacebookPost]: <FacebookIcon size={12} />,
  [CreativeType.TikTokVideo]: <Video size={12} />,
  [CreativeType.LinkedInPost]: <Linkedin size={12} />,
  [CreativeType.XPost]: <XLogo size={12} />,
  [CreativeType.YouTubeShort]: <Youtube size={12} />,
  [CreativeType.PinterestPin]: <PinterestIcon size={12} />,
}

interface CreativeTypeBadgeProps {
  type: CreativeType
  showLabel?: boolean
}

/**
 * Mono pill marking the creative's type. Sits next to the title in the
 * composer header. T3 chrome (bg-3 + line-bright + paper-dim text); the
 * icon takes the platform's brand identity by inheriting paper-dim — we
 * stay neutral here so the loud acid stays on the publish CTA.
 */
export function CreativeTypeBadge({ type, showLabel = false }: CreativeTypeBadgeProps) {
  const meta = creativeTypeMeta[type]
  return (
    <span className="mono inline-flex items-center gap-1.5 rounded-full border border-line-bright bg-bg-3 px-2 py-1 text-[11px] text-paper-dim">
      {typeIcons[type]}
      {showLabel && meta.label}
    </span>
  )
}
